import { render, staticRenderFns } from "./LoadFullscreen.vue?vue&type=template&id=e673468a&scoped=true&"
import script from "./LoadFullscreen.vue?vue&type=script&lang=js&"
export * from "./LoadFullscreen.vue?vue&type=script&lang=js&"
import style0 from "./LoadFullscreen.vue?vue&type=style&index=0&id=e673468a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e673468a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
